// Module
var code = "<div class=bible> <h2 class=passageref>Colossians 3.122-4.1</h2> <div class=bibletext> <p> <span class=rr>4</span><sup class=ww>1</sup>Masters, treat your slaves justly and fairly, for you know that you also have a Master in heaven. <br class=plus-b /></p><p> </p> </div></div>";
// Exports
module.exports = code;